import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useSession } from '@/core/auth/useSession';
import { ROUTES } from '@/core/config/routes';
export function RoleGuard({ roles, children }) {
    const { tieneAlgunRol } = useSession();
    const requeridos = Array.isArray(roles) ? roles : [roles];
    if (!tieneAlgunRol(requeridos)) {
        return _jsx(Navigate, { to: ROUTES.forbidden, replace: true });
    }
    return _jsx(_Fragment, { children: children });
}
